import { TranslationHelpers } from '../../i18n/translationHelpers';

export const services = Object.freeze({
    CROP: 'crop',
    FRANCE: 'france',
    RTV: 'rtv',
    VIBER: 'viber',
    KOBO: 'kobo',
});

export const animationServicesIds = [
    services.CROP,
    services.FRANCE,
    services.RTV,
    services.VIBER,
    services.KOBO,
];

export const content = [
    {
        id: services.CROP,
        name: 'Rakuten-Sites',
        title: 'visitor.rakuten.sites.title',
        body: 'visitor.rakuten.sites.body',
        links: [
            {
                link: 'https://rakuten.co.uk/',
                name: 'uk.name',
                siteText: 'visitor.rakuten.sites.action',
            },
            {
                link: 'https://rakuten.es/',
                name: 'spain.name',
                siteText: 'visitor.rakuten.sites.action',
            },
            {
                link: 'https://rakuten.de/',
                name: 'germany.name',
                siteText: 'visitor.rakuten.sites.action',
            },
        ],
        linkTexts: [
            TranslationHelpers.getFormattedMessage('visitor.rakuten.goto.link', {
                linkText: 'Rakuten UK',
            }),
            TranslationHelpers.getFormattedMessage('visitor.rakuten.goto.link', {
                linkText: 'Rakuten Spain',
            }),
            TranslationHelpers.getFormattedMessage('visitor.rakuten.goto.link', {
                linkText: 'Rakuten Germany',
            }),
        ],
        image: {
            desktop: '/assets/images/RakutenOEC_desktop.jpg',
            mobile: '/assets/images/RakutenOEC_mobile.jpg',
        },
        logo: {
            original: '/assets/logo/logo_rakuten_01.svg',
            white: '/assets/logo/logo_rakuten_01_white.svg',
        },
        alt: 'Rakuten logo',
        imageAlt: 'rakuten.image.alt',
        backgroundColor: 'linear-gradient(140deg, #904aa1, #bf0000 101%)',
        heading: TranslationHelpers.getFormattedMessage('visitor.rakuten.sites.heading'),
    },
    {
        id: services.FRANCE,
        name: 'Rakuten-France',
        title: 'visitor.rakuten.france.title',
        body: 'visitor.rakuten.france.body',
        links: [
            {
                link: 'https://fr.shopping.rakuten.com/',
                name: 'France',
                siteText: TranslationHelpers.getFormattedMessage('visitor.rakuten.france.action'),
            },
        ],
        linkTexts: [
            TranslationHelpers.getFormattedMessage('visitor.rakuten.goto.link', {
                linkText: 'Rakuten France',
            }),
        ],
        image: {
            desktop: '/assets/images/RakutenFrance_desktop.jpg',
            mobile: '/assets/images/RakutenFrance_mobile.jpg',
        },
        logo: {
            original: '/assets/logo/logo-france.svg',
            white: '/assets/logo/logo-france_white.svg',
        },
        alt: 'Rakuten France logo',
        imageAlt: 'france.image.alt',
        backgroundColor: 'linear-gradient(120deg, #83bbff, #7e171c 102%)',
        heading: TranslationHelpers.getFormattedMessage('visitor.rakuten.france.heading'),
    },
    {
        id: services.RTV,
        name: 'Rakuten-TV',
        title: 'visitor.rakuten.tv.title',
        body: 'visitor.rakuten.tv.body',
        links: [
            {
                link: 'https://rakuten.tv/',
                name: 'TV',
                siteText: TranslationHelpers.getFormattedMessage('visitor.rakuten.tv.action'),
            },
        ],
        linkTexts: [
            TranslationHelpers.getFormattedMessage('visitor.rakuten.goto.link', {
                linkText: 'Rakuten TV',
            }),
        ],
        image: {
            desktop: '/assets/images/RakutenTV_desktop.jpg',
            mobile: '/assets/images/RakutenTV_mobile.jpg',
        },
        logo: {
            original: '/assets/logo/logo_tv_01.svg',
            white: '/assets/logo/logo_tv_01_white.svg',
        },
        alt: 'Rakuten TV logo',
        imageAlt: 'tv.image.alt',
        backgroundColor: 'linear-gradient(120deg, #bf0000, #751313 102%)',
        heading: TranslationHelpers.getFormattedMessage('visitor.rakuten.tv.heading'),
    },
    {
        id: services.VIBER,
        name: 'Rakuten-Viber',
        title: 'visitor.rakuten.viber.title',
        body: 'visitor.rakuten.viber.body',
        links: [
            {
                link: 'https://viber.com/',
                name: 'Viber',
                siteText: TranslationHelpers.getFormattedMessage('visitor.rakuten.viber.action'),
            },
        ],
        linkTexts: [
            TranslationHelpers.getFormattedMessage('visitor.rakuten.goto.link', {
                linkText: 'Rakuten Viber',
            }),
        ],
        image: {
            desktop: '/assets/images/RakutenViber_desktop.jpg',
            mobile: '/assets/images/RakutenViber_mobile.jpg',
        },
        logo: {
            original: '/assets/logo/logo_viber_01.svg',
            white: '/assets/logo/logo_viber_01_white.svg',
        },
        alt: 'Rakuten Viber logo',
        imageAlt: 'viber.image.alt',
        backgroundColor: 'linear-gradient(120deg, #655cac, #271e6d 102%)',
        heading: TranslationHelpers.getFormattedMessage('visitor.rakuten.viber.heading'),
    },
    {
        id: services.KOBO,
        name: 'Rakuten-Kobo',
        title: 'visitor.rakuten.kobo.title',
        body: 'visitor.rakuten.kobo.body',
        links: [
            {
                link: 'https://www.kobo.com/',
                name: 'Kobo',
                siteText: TranslationHelpers.getFormattedMessage('visitor.rakuten.kobo.action'),
            },
        ],
        linkTexts: [
            TranslationHelpers.getFormattedMessage('visitor.rakuten.goto.link', {
                linkText: 'Rakuten Kobo',
            }),
        ],
        image: {
            desktop: '/assets/images/RakutenKobo_desktop.jpg',
            mobile: '/assets/images/RakutenKobo_mobile.jpg',
        },
        logo: {
            original: '/assets/logo/logo_kobo_01.svg',
            white: '/assets/logo/logo_kobo_01_white.svg',
        },
        alt: 'Rakuten Kobo logo',
        imageAlt: 'kobo.image.alt',
        backgroundColor: 'linear-gradient(120deg, #e25f25 0%, #b61648 102%)',
        heading: TranslationHelpers.getFormattedMessage('visitor.rakuten.kobo.heading'),
    },
];
